export default {
  Password: 'password-form__password',
  ConfirmPassword: 'password-form__confirm-password',
  CreateAccountButton: 'password-form__create-account-button',
  GoBackButton: 'password-form__go-back-button'
};
